//handle public directory stuff. Call from the view with PublicDirectory.init();
var PublicDirectory = function (){

    var _init = function(){

        $('#directory-sort').select2({
            minimumResultsForSearch: Infinity,
        });

        $('#directory-country-filter').select2({
            minimumResultsForSearch: Infinity,
            allowClear: true,
            templateSelection:function(op){
                if (!op.id) { return op.text; }
                var $op = $('<span class="text-nowrap"><img class="mr-2" width="20" src="/pragmarx/countries/flag/file/'+$('#directory-country-filter').find(':selected').data('cca3')+'.svg">' + op.text + '</span>');
                return $op;
            },
            templateResult:function(op){
                if (!op.id) { return op.text; }
                var $op = $('<span class="text-nowrap"><img class="mr-2" width="20" src="/pragmarx/countries/flag/file/'+$('#directory-country-filter').find('option[value='+op.id+']').data('cca3')+'.svg">' + op.text + '</span>');
                return $op;
            }
        }).on('change',function(){
            var url = getUrlWithSearchParams();
            location.assign( url );
        });
        
        $('#directory-specialism').select2({
            allowClear: true,
        }).on('change',function(){  
            var url = getUrlWithSearchParams();
            location.assign( url );
        });
        
        $('#search-refine').off().on('submit',function(){
            var url = getUrlWithSearchParams();
            location.assign( url );
        });
        
    }

    return {
        init: function(){
            _init();
        }
    }
}();

var getUrlWithSearchParams = function(){

    var url = new URL(location.href);

    url.searchParams.delete('page');
    url.searchParams.delete('q');
    url.searchParams.delete('s');
    url.searchParams.delete('c');

    var q = $('#search-refine').find('input[name="q"]').val();
    var s = $('#directory-specialism').find(':selected').text();
    var c = $('#directory-country-filter').find(':selected').val();

    if(q && q.length > 0){
        url.searchParams.set('q', q);
    }
    if(s && s.length > 0){
        url.searchParams.set('s', s);
    }
    if(c && c.length > 0){
        url.searchParams.set('c', c);
    }

    return url;

}